const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: 'File Name',
        dataIndex: 'FileName',
        render: defaultRender,
    },
    {
        title: 'File No.',
        dataIndex: 'file_number',
        render: defaultRender,
    },
    {
        title: 'Frequency Type',
        dataIndex: 'frequency_type',
        render: defaultRender,
    },
    {
        title: 'Date Created',
        dataIndex: 'created_at',
        render: defaultRender,
    },
    {
        title: 'Status',
        dataIndex: 'status',
        render: defaultRender,
    },
    {
        title: 'Action',
        dataIndex: 'action',
        render: defaultRender,
    },
];

export default columns;